var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-row',[_c('vs-col',{attrs:{"vs-lg":"6","vs-sm":"12"}},[_c('menus')],1),_c('vs-col',{attrs:{"vs-lg":"6","vs-sm":"12"}},[_c('categories')],1)],1),_c('vs-row',[_c('vs-col',{attrs:{"vs-lg":"6","vs-sm":"12"}},[_c('addons')],1),_c('vs-col',{attrs:{"vs-lg":"6","vs-sm":"12"}},[_c('labels')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }